const SELECTORS = [
  '.form-group.has-danger',
  '.form-check.has-danger',
  '.form-control.has-danger',
];

up.$compiler(SELECTORS.join(', '), { batch: true }, ($element) => {
  setTimeout(() => {
    up.reveal($element.first())
  })
})
